import { createContext } from 'react';

export type AppBootstrapStatus = 'idle' | 'auth-initializing' | 'awaiting-auth' | 'bootstrapping' | 'ready' | 'error';

export interface AppBootstrapContextValue {
    status: AppBootstrapStatus;
    isBootstrapping: boolean;
    isReady: boolean;
    isAuthenticated: boolean;
    hasResolvedAuth: boolean;
    organizationsCount: number | null;
    error: unknown | null;
    retry: () => Promise<void>;
}

export const AppBootstrapContext = createContext<AppBootstrapContextValue | null>(null);
